export interface TabDef { id: string; label: string }
/** Bölümlü seçici: kâğıt zemin üzerinde beyaz aktif dilim; ince cetvel kenarlığı. size="sm" tablo başlıkları için. */
export function Tabs({ tabs, active, onChange, size = "md", label }: { tabs: TabDef[]; active: string; onChange: (id: string) => void; size?: "sm" | "md"; label?: string }): JSX.Element {
  const pad = size === "sm" ? "px-2 py-1 text-xs" : "px-3 py-1.5 text-[13px]";
  return (
    <div role="tablist" aria-label={label} className="inline-flex flex-wrap gap-0.5 rounded border border-rule bg-page p-0.5">
      {tabs.map((t) => (
        <button key={t.id} role="tab" type="button" aria-selected={t.id === active} aria-controls={`panel-${t.id}`} onClick={() => onChange(t.id)}
          className={`${pad} rounded cursor-pointer transition-colors duration-150 ${t.id === active ? "bg-sheet text-ink font-medium shadow-[0_1px_0_rgb(22_35_59_/_0.08)]" : "text-stone hover:text-ink"}`}>{t.label}</button>
      ))}
    </div>
  );
}
